<script>

import { trans } from '@/utils';

export let principles;
export let projects;

$: counters = projects.reduce((prev, cur) => {
    cur.principles.forEach(pri => {
        if (!(pri.id in prev)) {
            prev[pri.id] = 1;
        } else {
            prev[pri.id]++;
        }
    })
    return prev;
}, {});

// $: max = Math.max(...Object.values(counters));

$: num = projects.length;

$: data = principles.filter(p => counters[p.id] > 0).map((p) => {
    return {
        name: p.name,
        color: p.color,
        y: counters[p.id]
    };
});

function highcharts(node) {
    const chart = Highcharts.chart(node, {
        title: {
          text: num.toString(),
          y: 51
        },
        legend: false,
        chart: {
            type: 'pie',
            margin: [0, 0, 0, 0]
        },
        credits: {
          enabled: false
        },
        plotOptions: {
            pie: {
                shadow: false,
                allowPointSelect: true,
                center: ['50%', '50%'],
                cursor: 'pointer'
            }
        },
        tooltip: {
            formatter: function() {
                // return '<b>'+this.point.name+'</b>: '+this.y+' ('+this.point.percentage.toFixed(2)+')%';
                return '<b>'+this.point.name+'</b>: '+this.y+' '+(this.y > 1 ? trans('n_initiatives') : trans('1_initiative'));
            }
        },
        series: [
            {
                data: data,
                size: '100%',
                innerSize: '50%',
                id: 'data',
                name: trans('title_initiatives'),
                dataLabels: {
                    enabled: false
                }
            }
        ]
    });

    return {
		destroy() {
			chart.destroy();
		}
	};
}


</script>


<div class="chart" style="width:170px;height:110px" use:highcharts></div>
